import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Environment, Response, Notification } from '@viso/core/models';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT } from '../environment/environment.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private $unreadNotification = new BehaviorSubject<any>(null);

    constructor(
        private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) { }


    public startRegistration() {
        this.readNotificationCount();
    }

    private readNotificationCount() {
        this.getNotificationCount()
        .subscribe(res => {
            this.$unreadNotification.next(res.body);
        });
    }

    getUnreadNotification() {
        return this.$unreadNotification.asObservable();
    }

    getNotifications(page = 0, limit = 20): Observable<any> {
        return this.http.get<Response<Notification[]>>(`${this.environment.API_URL}/notification/list`, {
            params: {
                page: page.toString(),
                limit: limit.toString()
            }
        });
    }
    
    getNotificationCount() {
        return this.http.get<Response<Notification[]>>(`${this.environment.API_URL}/notification/count`);
    }

    markAsRead(notificationId: number): Observable<any> {
        return this.http.post(`${this.environment.API_URL}/notification/read`, {
            notification_id: notificationId
        });
    }

    markAllAsRead(notificationId: number[]): Observable<any> {
        return this.http.post(`${this.environment.API_URL}/notification/read-all`, {
            ids: notificationId
        });
    }
    
}
